/**
 * Created by mukund on 7/24/17.
 */

angular.module('mediacloudApp')
    .directive('itemManagement', ['$rootScope', '$state', '$timeout', '$q', '$filter', 'CollectionService', 'BaseFileService', 'BatchService', 'UploadErrors', 'SearchService', 'SchedulerService', 'AssetService', function($rootScope, $state, $timeout, $q, $filter, CollectionService, BaseFileService, BatchService, UploadErrors, SearchService, SchedulerService, AssetService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/item-management/item-management.html',
            scope: {
                render: '=',
                renderSource: '=',
                content: '=',
                account: '=',
            },
            link: function (scope, element, attrs) {

                if (scope.account) {

                    var origin;

                    // For pagination
                    scope.collectionsPerPage = 10;
                    scope.currentPage = 1;
                    scope.collectionPath = '';
                    scope.collectionTitle = '';
                    scope.destinationCollectionIdChanged = false;
                    scope.headerText = '';
                    scope.subheaderText = '';
                    scope.buttonText = '';
                    scope.setDisabled = false;
                    scope.currentCollectionId = $state.params.collectionId;
                    scope.prevCollectionId = $state.params.collectionId;
                    scope.showAdditionalCourses = false;
                    scope.hasRole = false;
                    scope.showAdditionalCourses = scope.hasRole;
                    scope.closeFolderSelectionModal = function () {
                        if(scope.content && scope.content.item !== undefined){
                            scope.currentCollectionId = scope.content.item[0].parent.cid;
                        }
                        scope.getFoldersForPublishing();
                        $('#itemManagementWindow').modal('hide');
                        $('.modal').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        //scope.content.item = null;
                        if(scope.$parent.$parent!==null){
                            scope.$parent.$parent.content = null;
                        }
                        $(".new-modal-content").hide();
                        setTimeout(function () {
                            if($(".new-modal-content").is(":visible")===false){
                                $(".new-modal-content").show();
                            }
                        }, 500);

                    };

                    scope.checkDisabled = true;

                    scope.showSpinnerFn = function () {
                        $('.overlay-main').css('width', '100%');
                        $('.overlay-main').css('height', '100%');
                        $('.overlay-main').show();
                    };

                    scope.hideSpinner = function () {
                        $('.overlay-main').css('width', '0%');
                        $('.overlay-main').css('height', '0%');
                        $('.overlay-main').hide();
                    };

                    // TODO refactor if possible
                    var getChildFolders = function (pcid, $event) {
                        // Reset pagination every time we load a new level of children
                        scope.currentPage = 1;
                        if (pcid === '101') {
                            CollectionService.GetAllCollections.get({type: 'COURSE', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else if (pcid === '100') {
                            CollectionService.GetAllCollections.get({type: 'CHANNEL', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else if (pcid === '104') {
                            CollectionService.GetAllCollections.get({type: 'PROTECTED', limit: scope.collectionsPerPage, offset: (scope.currentPage - 1) * scope.collectionsPerPage, paginated: true}, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    showChildFolders(result.collections, $event);
                                    scope.expandedFolder.totalCollections = result.totalCollections;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        } else {
                            CollectionService.GetCollectionContent.get({
                                cid: pcid,
                                fol: true,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                limit: scope.collectionsPerPage,
                                sortOn: "publishedDate"
                            }, function (result) {
                                if (result.contents && result.contents.length > 0) {
                                    showChildFolders(result.contents, $event);
                                    scope.expandedFolder.totalCollections = result.totalContents;
                                } else {
                                    showChildFolders([], $event);
                                    scope.expandedFolder.totalCollections = 0;
                                }
                            });
                        }
                    };

                    scope.loadMoreFolders = function(){
                        scope.showSpinner = true;
                        scope.currentPage++;

                        if(scope.searchEnabled){

                            var sitewide = true,
                                collectionId = '';

                            if ($state.params.collectionId && $state.params.collectionId !== "000") {
                                sitewide = false;
                                collectionId = $state.params.collectionId;
                            }

                            SearchService.SearchCollections.get({
                                query: scope.searchField.query,
                                sitewide: sitewide,
                                cid: collectionId,
                                limit: scope.collectionsPerPage,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage
                            }, function (result) {
                                scope.showSpinner = false;
                                if (result.collections && result.collections.length > 0) {
                                    scope.childFolders = scope.childFolders.concat(result.collections);
                                }
                                // We re-purpose the expandedFolder variable for the search results screen
                                scope.expandedFolder = {title: "Search Results"};
                                scope.expandedFolder.totalCollections = result.totalCollections ? result.totalCollections : 0;
                            });

                        } else {
                            var parent = scope.expandedFolder;
                            if (parent.path === '/') {
                                CollectionService.GetAllCollections.get({
                                    type: parent.type.toUpperCase(),
                                    limit: scope.collectionsPerPage,
                                    offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                    paginated: true
                                }, function (result) {
                                    scope.showSpinner = false;
                                    if (result.collections && result.collections.length > 0) {
                                        scope.childFolders = scope.childFolders.concat(result.collections);
                                    }
                                    parent.totalCollections = result.totalCollections ? result.totalCollections : 0;
                                });
                            } else {
                                var pcid = parent.cid ? parent.cid : parent.xid;
                                CollectionService.GetCollectionContent.get({
                                    cid: pcid,
                                    fol: true,
                                    offset: (scope.currentPage - 1) * scope.collectionsPerPage,
                                    limit: scope.collectionsPerPage
                                }, function (result) {
                                    scope.showSpinner = false;
                                    if (result.contents && result.contents.length > 0) {
                                        scope.childFolders = scope.childFolders.concat(result.contents);
                                    }
                                    parent.totalCollections = result.totalContents ? result.totalContents : 0;
                                });
                            }
                        }
                        $.each(scope.childFolders, function (k, v) {
                            $.each(scope.content.item, function (t, u) {
                                v.disableColl = v.xid === u.xid;
                            })
                        });
                    };

                    scope.setExpandedFolder = function(parent, $event, addChildColumn){
                        scope.searchEnabled = false;
                        if(parent.path === '/'){
                            setOrigin(parent);
                        } else {
                            selectFolder(parent, $event);
                        }
                        if(addChildColumn) {
                            scope.folderColumns.push(1);
                        }
                        scope.expandedFolder = parent;
                        if (scope.expandedFolder != null && ["100","101", "103", "104", "106"].includes(scope.expandedFolder.cid)) {
                            if (scope.content.item != null && scope.content.item.length >= 1) {
                                if (scope.content.item.filter(e => e.type === 'Collection').length == scope.content.item.length) {
                                    scope.setDisabled = false;
                                    scope.selectedFolder = true;
                                }
                            }
                            else {
                                scope.setDisabled = true;
                            }
                        }
                        var pcid = parent.cid ? parent.cid : parent.xid;
                        getChildFolders(pcid, $event);
                        $timeout(function () {
                            var currentleft = (scope.folderColumns.length - 1) * 100 * -1;
                            var newleft = (currentleft - 100) + '%';
                            $('.folder-column').css( "left", newleft );
                        }, 0, false);
                    };

                    var setOrigin = function(parent){
                        origin = parent;
                    };

                    var resetOrigin = function(pcid){
                        var newOrigin = scope.parentFolders[0];
                        if (pcid === '100') {
                            newOrigin = scope.parentFolders[1];
                        }
                        setOrigin(newOrigin);
                    };

                    // TODO refactor if possible
                    scope.getParentFolders = function($event){
                        if (!scope.expandedFolder && !scope.expandedFolder.path) return;

                        var pcid = scope.expandedFolder.path.substring(scope.expandedFolder.path.lastIndexOf("/") + 1);

                        if (!scope.showAdditionalCourses) {
                            var currentleft = scope.folderColumns.length * 100 * -1;
                            var newleft = (currentleft + 100) + '%';
                            $('.folder-column').css( "left", newleft );
                            scope.showBackButton = false;
                            scope.folderColumns.pop();
                        }
                        else {
                            //if () {
                            if (['100', '101', '104'].includes(pcid)) {
                                if (scope.folderColumns.length > 1) {
                                    scope.folderColumns.pop();
                                }
                            }
                            else {
                                if (scope.folderColumns.length != 1 && scope.expandedFolder.path !== '/') {
                                    var currentleft = scope.folderColumns.length * 100 * -1;
                                    var newleft = (currentleft + 100) + '%';
                                    $('.folder-column').css( "left", newleft );
                                    scope.showBackButton = false;
                                    scope.folderColumns.pop();
                                }
                                else if (scope.expandedFolder.path == '/') {
                                    var currentleft = scope.folderColumns.length * 100 * -1;
                                    var newleft = (currentleft + 100) + '%';
                                    $('.folder-column').css( "left", newleft );
                                    scope.showBackButton = false;
                                    scope.folderColumns.pop();
                                    scope.setDisabled = true;
                                }
                            }
                        }

                        // The home screen will be shown. There is nothing else to do here.
                        if(scope.expandedFolder.path === '/'){
                            scope.showBackButton = false;
                            return;
                        }

                        if(pcid === '101'  || pcid === '104' || pcid === '100'){
                            resetOrigin(pcid);
                            if((origin && origin.type.toLowerCase() === 'course') || (!origin && pcid === '101')){
                                scope.setExpandedFolder(scope.parentFolders[0], undefined, false);
                            } else if((origin && origin.type.toLowerCase() === 'channel') || (!origin && pcid === '100')){
                                scope.setExpandedFolder(scope.parentFolders[1], undefined, false);
                                pcid = scope.expandedFolder.cid;
                            }
                            else if($state.params.collectionId && $state.params.collectionId !== "000") {
                                scope.showBackButton = true;
                            }
                            getChildFolders(pcid, $event);
                            scope.selectedFolder = false;
                        } else {
                            var parentType = 'COURSE';

                            if(scope.expandedFolder.path.startsWith("/104")) {
                                parentType = 'PROTECTED';
                            } else if(scope.expandedFolder.path.startsWith("/100")) {
                                parentType = 'CHANNEL';
                            }

                            CollectionService.GetCollection.get({
                                cid: pcid,
                                type: parentType
                            }, function (result) {
                                scope.showBackButton = pcid.split('/').length > 2;
                                if(scope.folderColumns.length){
                                    scope.setExpandedFolder(result, $event, false);
                                } else {
                                    scope.setExpandedFolder(result, $event, true);
                                }
                            });
                        }
                    };



                    var showChildFolders = function (children, $event) {
                        var pcid = scope.expandedFolder.path.substring(scope.expandedFolder.path.lastIndexOf("/") + 1);
                        if($state.params.collectionId && $state.params.collectionId !== "000") {
                            var expandedFolderId = scope.expandedFolder.cid ? scope.expandedFolder.cid : scope.expandedFolder.xid;
                            if( expandedFolderId === $rootScope.rootLevelCid && !scope.showAdditionalCourses) {
                                scope.showBackButton = false;
                            } else {
                                if (expandedFolderId == $state.params.collectionId) {
                                    if (scope.showAdditionalCourses || ($rootScope.rootLevelCid && expandedFolderId != $rootScope.rootLevelCid)) {
                                        scope.showBackButton = true;
                                    }
                                    else {
                                        scope.showBackButton = expandedFolderId !== $rootScope.rootLevelCid && scope.hasRole && ['100', '101', '103', '104'].indexOf(pcid) === -1;
                                    }
                                }
                                else {
                                    scope.showBackButton = true;
                                }
                            }
                        } else {
                            scope.showBackButton = true;
                        }
                        if (scope.content && scope.content.item) {
                            $.each(children, function (k, v) {
                                $.each(scope.content.item, function (t, u) {
                                    if (v.xid === u.xid && !v.disableColl) {
                                        v.disableColl = true;
                                    }
                                    else if (v.disableColl) {
                                        v.disableColl = true;
                                    }
                                    else {
                                        v.disableColl = false;
                                    }
                                })
                            });
                        }
                        scope.childFolders = [].concat(children);
                        if (scope.showAdditionalCourses && !scope.parentFolders) {
                            scope.parentFolders = [
                                {
                                    title: 'Courses',
                                    cid: '101',
                                    type: 'course',
                                    acl: 'RW',
                                    path: '/'
                                },
                                {
                                    title: 'Channels',
                                    cid: '100',
                                    type: 'channel',
                                    acl: 'RW',
                                    path: '/'
                                }
                            ];
                        }
                    };

                    var selectFolder = function (folder, event) {
                        scope.selectedFolder = folder;
                        if (scope.selectedFolder.cid && scope.selectedFolder.cid == scope.currentCollectionId) {
                            scope.currentCollectionFolder = scope.selectedFolder;
                        }

                        console.log('selectFolder(): ', folder);
                        if(event) {
                            event.stopPropagation()
                        }
                    };

                    scope.getFoldersForPublishing = function () {

                        // Array used by ng-repeat used for folder transition effect
                        scope.folderColumns = [];

                        $('.folder-column').css( "left", "0%" );

                        scope.searchEnabled = false;
                        scope.childFolders = [];
                        scope.folderPath = [];
                        scope.showBackButton = false;
                        scope.expandedFolder = null;
                        scope.searchField = {query: ''};
                        scope.selectedFolder = null;
                        scope.currentCollectionFolder = null;

                        // 000 - collectionId is equivalent to no collectionId
                        if (scope.currentCollectionId && scope.currentCollectionId !== "000") {
                            CollectionService.GetCollection.get({
                                cid: scope.currentCollectionId,
                                type: 'COURSE'
                            }, function (result) {
                                scope.setExpandedFolder(result, undefined, true);
                            });
                        }
                        console.log('finish getFoldersForPublishing ')
                    };

                    scope.moveItems = function(items) {
                        var deferred = $q.defer();
                        var moveItem = new BaseFileService.MoveItem({
                            contents: items,
                            totalContents: items.length
                        });
                        moveItem.$save(function (response) {
                            console.log('moveItem resp: ', response);
                            scope.$parent.$parent.renderSource = 'Move';
                            scope.$parent.$parent.render = true;
                            scope.closeFolderSelectionModal();

                            if (items[0].collectionContentDTO.type == 'Quiz' && scope.$parent.quiz) {
                                $state.go('quizzing', {
                                    collectionId: items[0].destinationCollectionId,
                                    assetId: items[0].collectionContentDTO.xid,
                                    collectionType: 'course',
                                    isNewQuiz: false,
                                    isFromPnP: false
                                });

                                setTimeout(function () {
                                    $rootScope.movingAsset = {
                                        collectionId: items[0].destinationCollectionId,
                                        type: scope.expandedFolder.type
                                    }
                                    scope.hideSpinner();
                                }, 4000);
                            }
                            else {
                                // only redirect to playback if currently on playback page
                                if ($('article.playback').length) {
                                    var params = {
                                        collectionId: items[0].destinationCollectionId,
                                        assetId: items[0].collectionContentDTO.xid,
                                        rootCollectionId: $rootScope.rootLevelCid,
                                        path: items[0].collectionContentDTO.path
                                    };
                                    $state.go('playback', params);
                                }

                                setTimeout(function () {
                                    $rootScope.movingAsset = {
                                        collectionId: items[0].destinationCollectionId,
                                        type: scope.expandedFolder.type
                                    }
                                    scope.hideSpinner();
                                }, 4000);
                            }

                            deferred.resolve(response);
                        }, function (error) {
                            deferred.reject(error);
                        });

                        return deferred.promise;
                    }

                    scope.publishFile = function (confirmed, makeAvailable) {
                        var collectionId = scope.selectedFolder.cid ? scope.selectedFolder.cid : scope.selectedFolder.xid,
                            path = scope.selectedFolder.path;

                        console.log('from publishFile scope.selectedFolder', scope.selectedFolder)
                        console.log('from publishFile scope', scope)
                        if (!collectionId && scope.expandedFolder != null) {
                            collectionId = scope.expandedFolder.cid;
                        }
                        // individual recording first pass
                        var items = [];
                        console.log('Operation: ', scope.content.type);
                        console.log('Items: ', scope.content.item);
                        console.log('Items Length: ', scope.content.item.length);
                        $.each(scope.content.item, function(k, file) {
                            var item = {};
                            item.collectionContentDTO = file;
                            item.destinationCollectionId = collectionId;
                            items.push(item);
                        });
                        // move
                        if (scope.content.type == 'Move' || scope.content.type == 'Publish') {
                            $('#hiddenCollectionId').val(collectionId);
                            console.log('scope for itemManagement: ', scope);
                            console.log(scope.content.type + ' items: ', items);
                            if (scope.content.type == 'Publish') {
                                var assetActiveStatusDTO = {
                                    assetId: items[0].collectionContentDTO.xid ? items[0].collectionContentDTO.xid : items[0].collectionContentDTO.aid,
                                    active: true,
                                };
                                var itemType = scope.content.item[0].type;

                                var makeQuizAvailable = $("#cbMakeQuizAvailable").is(":checked");
                                if (!confirmed && itemType == 'Quiz' && makeQuizAvailable) {
                                    $("#quizAvailableModal").modal({
                                        backdrop: "static",
                                        keyboard: false,
                                    });
                                    $(".new-modal-content").hide();
                                    setTimeout(function(){
                                        $("#quizAvailableModalLabel").focus();
                                    },500);
                                    return;
                                }
                                scope.showSpinnerFn();
                                AssetService.SetActiveStatus.send(
                                    assetActiveStatusDTO,
                                    function(response) {
                                        var parentCid = scope.content.item[0].parent ? scope.content.item[0].parent.cid : scope.content.item[0].cid;
                                        var movePromise = $q.when();

                                        if (collectionId != parentCid) {
                                            movePromise = scope.moveItems(items);
                                        }
                                        else {
                                            console.log('publish resp: ', response);
                                            scope.$parent.$parent.renderSource = 'Publish';
                                            scope.$parent.$parent.render = true;
                                            scope.closeFolderSelectionModal();
                                            setTimeout(function () {
                                                scope.hideSpinner();
                                            }, 500);
                                        }
                                        if (itemType == 'Quiz') {
                                            var quizPublishDTO = {
                                                assetId: items[0].collectionContentDTO.xid,
                                                title: items[0].collectionContentDTO.title,
                                                collectionId: items[0].destinationCollectionId,
                                                makeAvailable: makeAvailable,
                                                token: localStorage.getItem("launchToken"),
                                                state: localStorage.getItem("launchState")
                                            };

                                            // Publish after move completes so the quiz is in the new collection
                                            movePromise.then(function () {
                                                AssetService.PublishQuiz.send(quizPublishDTO, function (resp) {
                                                    scope.$parent.$parent.render = true;
                                                    $("#quizUnavailableModal").modal("hide");
                                                    scope.$emit('reloadQuiz', { reload: true });
                                                });
                                            });
                                        }
                                    }
                                );
                            }
                            else {
                                scope.moveItems(items);
                            }
                        }
                        else if (scope.content.type == 'Copy') {
                            for (var item of items) {
                              if (item.collectionContentDTO.type == 'Quiz') {
                                item.makeAvailable = $("#cbMakeQuizAvailable").is(":checked");
                              }
                            }
                            var copyItem = new BaseFileService.CopyItem({
                               contents: items,
                               totalContents: items.length
                            });
                            copyItem.$save(function (response) {
                                console.log('copyItem resp: ', response);
                                scope.$parent.$parent.renderSource = 'Copy';
                                scope.$parent.$parent.render = true;
                                scope.closeFolderSelectionModal();
                                setTimeout(function () {
                                    scope.hideSpinner();
                                }, 4000);
                            }, function () {
                            });
                        }
                        else {
                            // invalid state, error out.
                            alert('An error occurred. Please try again.');
                        }
                    };

                    scope.checkForSpace = function (item, isChild, event) {
                        if (event.keyCode === 32) {
                            // Ensures My Courses/ Channels doesn't get selected
                            if (!isChild && ['100', '101', '104'].indexOf(item.cid) > -1) {
                                return;
                            }
                            selectFolder(item, event);
                        } else if (event.keyCode === 13) {
                            scope.setExpandedFolder(item, event, true);
                        }
                    };

                    scope.checkForEnter = function (event) {
                        if (event.keyCode === 13) {
                            scope.searchForFolder();
                        }
                    };

                    scope.searchForFolder = function () {
                        if(scope.searchField.query) {
                            scope.searchTerm = scope.searchField.query;
                            scope.searchEnabled = true;
                            $('.folder-column').css("left", "0%");
                            scope.folderColumns = [1];
                            scope.currentPage = 1;

                            var sitewide = true,
                                collectionId = '';

                            if ($state.params.collectionId && $state.params.collectionId !== "000") {
                                sitewide = false;
                                collectionId = $state.params.collectionId;
                            }

                            if (scope.showAdditionalCourses) {
                                sitewide = true;
                            }

                            SearchService.SearchCollections.get({
                                query: scope.searchField.query,
                                sitewide: sitewide,
                                cid: collectionId,
                                limit: scope.collectionsPerPage,
                                offset: (scope.currentPage - 1) * scope.collectionsPerPage
                            }, function (result) {
                                if (result.collections && result.collections.length > 0) {
                                    scope.childFolders = [].concat(result.collections);
                                } else {
                                    scope.childFolders = [];
                                }
                                // We re-purpose the expandedFolder variable for the search results screen
                                scope.expandedFolder = {title: "Search Results"};
                                scope.expandedFolder.totalCollections = result.totalCollections ? result.totalCollections : 0;
                                if (scope.content.item) {
                                    $.each(scope.childFolders, function (k, v) {
                                        $.each(scope.content.item, function (t, u) {
                                            if (v.xid === u.xid) {
                                                v.disableColl = true;
                                            }
                                            if (v.path != null && u.xid && v.path.includes(u.xid)) {
                                                v.disableColl = true;
                                            }
                                            if (v.cid === u.xid) {
                                                v.disableColl = true;
                                            }
                                        });
                                    });
                                }
                            });

                            $timeout(function () {
                                var currentleft = (scope.folderColumns.length - 1) * 100 * -1;
                                var newleft = (currentleft - 100) + '%';
                                $('.folder-column').css("left", newleft);
                            }, 0, false);
                        } else {
                            scope.cancelSearch();
                        }
                    };

                    scope.cancelSearch = function() {
                        scope.setExpandedFolder(scope.currentCollectionFolder, undefined, true);
                    };

                    scope.loadContent = function() {
                        console.log('item-management content: ', scope.content);

                        if(scope.content && scope.content.item){
                            scope.hasRole = scope.$parent.isContentManager;
                            scope.showAdditionalCourses = scope.hasRole
                            scope.parentFolders = null;
                            var objectType = 'folder';
                            var objectTypeTitle = 'Folder';

                            if (scope.content && scope.content.item && scope.content.item.length) {
                                if (scope.content.item[0].parent) {
                                    scope.currentCollectionId = scope.content.item[0].parent.cid;
                                } else if (scope.content.$parent) {
                                    scope.currentCollectionId = scope.content.$parent.collectionId;
                                }

                                if (scope.content.item.some(obj => obj.type !== scope.content.item[0].type)) {
                                    objectType = 'item';
                                    objectTypeTitle = 'Item';
                                }
                                else if (scope.content.item.some(e => e.type === 'Collection')) {
                                    objectType = 'folder';
                                    objectTypeTitle = 'Folder';
                                }
                                else if (scope.content.item.some(e => e.type === 'Video')) {
                                    objectType = 'media asset';
                                    objectTypeTitle = 'Media Asset';
                                }
                                else if (scope.content.item.some(e => e.type === 'Quiz')) {
                                    objectType = 'quiz';
                                    objectTypeTitle = 'Quiz';
                                }

                                if(scope.content.item.length > 1) {
                                    if (objectType == 'quiz') {
                                        objectType += 'zes';
                                        objectTypeTitle += 'zes';
                                    }
                                    else {
                                        objectType += 's';
                                        objectTypeTitle += 's';
                                    }
                                }
                            }

                            scope.headerText = scope.content.type + ' ' + objectTypeTitle;

                            if(scope.content.item.length > 1){
                                scope.headerText += ' (' + scope.content.item.length + ')';
                            }

                            var theSuffix = scope.content.item.length > 1 ? 'se' : '';

                            var action = 'moved';
                            if (scope.content.type == 'Copy') {
                                action = 'copied';
                            }
                            else if (scope.content.type == 'Publish') {
                                action = 'published';
                            }
                            else {
                                action = 'moved';
                            }

                            scope.subheaderText = 'The' + theSuffix + ' ' + objectType + ' will be ' + action + ' to the Destination Folder that you select.';
                            scope.buttonText = scope.content.type;

                            //as there can be more than one item selected, it doesn't make sense to display the item[0].title.
                            // scope.collectionTitle = 'this is the title'
                            if(scope.$parent) {
                                scope.collectionPathRestricted =
                                    scope.$parent.currentCollection.titlePath.substring(
                                        scope.$parent.currentCollection.titlePath.indexOf($rootScope.rootLevelCollectionTitle),
                                        scope.$parent.currentCollection.titlePath.length);

                                scope.collectionPath = scope.$parent.currentCollection.titlePath;
                            }

                            scope.getFoldersForPublishing();
                            $("#child-folder-column").bind('scroll', function() {
                               console.log('Event worked');
                            });
                        }
                    }


                    scope.$watch(function () {
                             return scope.content;
                         }, function(){
                        scope.loadContent();
                    }, true);

                    scope.$on('reloadPublishModal', function(event, data) {
                        if (data.reload && scope.content && scope.content.item) {
                            scope.loadContent();
                        }
                    });

                    scope.$watch('selectedFolder', function(val) {
                        //The original condition in ng-disabled attribute was:
                        //  ng-disabled="!selectedFolder || (zoomfile.moveAsset && destinationCollectionIdChanged)"
                        //As the "zoomfile" variable doesn't exist in this component, the only way to make this
                        //condition be true is to check if "selectedFolder" is true or false.
                        scope.setDisabled = false;
                        var actionBtn = $('#itemManagementBtn');
                        if (!scope.selectedFolder && scope.expandedFolder != null && ["100","101", "103", "104", "106"].includes(scope.expandedFolder.cid)) {
                            if (scope.content && scope.content.item != null && scope.content.item.length >= 1) {
                                if (scope.content.item.filter(e => e.type === 'Collection').length == scope.content.item.length) {
                                    scope.setDisabled = false;
                                    scope.selectedFolder = true;
                                }
                            }
                            else {
                                scope.setDisabled = true;
                            }
                        }
                        if(scope.selectedFolder) {
                            var currentFolder = scope.selectedFolder.cid ? scope.selectedFolder.cid : scope.selectedFolder.xid;
                            var disable = false;
                            if (actionBtn && scope.content && scope.content.item && scope.content.item.length == 1) {
                                var item = scope.content.item[0];
                                // single collection
                                if (item.type == 'Collection') {
                                    // copy
                                    if (scope.content.type === 'Copy') {
                                        if (item.xid === currentFolder) {
                                            scope.setDisabled = true;
                                            //actionBtn.attr('disabled', true);
                                        }
                                        else {
                                            scope.setDisabled = false;
                                            //actionBtn.attr('disabled', false);
                                        }
                                    }
                                    // move or publish
                                    else if (scope.content.type === 'Move') {
                                        if (actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') != 'true') {
                                            actionBtn.attr('atParent', true);
                                        }
                                        else {
                                            actionBtn.attr('atParent', item.xid === currentFolder);
                                        }
                                        actionBtn.attr('atRoot', scope.currentCollectionId == currentFolder);
                                        var withinColl = actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') == 'false';
                                        if (item.parent.cid === currentFolder || item.xid === currentFolder || withinColl) {
                                            scope.setDisabled = true;
                                            //actionBtn.attr('disabled', true);
                                        }
                                        else {
                                            scope.setDisabled = false;
                                            //actionBtn.attr('disabled', false);
                                        }
                                    }
                                }
                                // single asset
                                else {
                                    // copy
                                    if (scope.content.type === 'Copy') {
                                        if (
                                            (item.parent && item.parent.cid === currentFolder) ||
                                            (item.cid === currentFolder)
                                        ) {
                                            scope.setDisabled = true;
                                            //actionBtn.attr('disabled', true);
                                        }
                                        else {
                                            scope.setDisabled = false;
                                            //actionBtn.attr('disabled', false);
                                        }
                                    }
                                    // move
                                    else if (scope.content.type === 'Move') {
                                        if (actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') != 'true') {
                                            actionBtn.attr('atParent', true);
                                        }
                                        else {
                                            if(item.parent) {
                                                actionBtn.attr('atParent', item.parent.cid === currentFolder);
                                            } else {
                                                actionBtn.attr('atParent', item.cid === currentFolder);
                                            }

                                        }
                                        actionBtn.attr('atRoot', scope.currentCollectionId == currentFolder);
                                        var withinColl = actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') == 'false';

                                        if (
                                            (item.parent && item.parent.cid === currentFolder || withinColl) ||
                                            (item.cid === currentFolder || withinColl)
                                        ) {
                                            scope.setDisabled = true;
                                            //actionBtn.attr('disabled', true);
                                        }
                                        else {
                                            scope.setDisabled = false;
                                            //actionBtn.attr('disabled', false);
                                        }
                                    }
                                    else {
                                        scope.setDisabled = false;
                                    }
                                }
                            }
                            else if (scope.content && scope.content.item && scope.content.item.length > 1) {
                                for(var item of scope.content.item) {
                                    // multiple collections
                                    if (item.type == 'Collection') {
                                        // copy
                                        if (scope.content.type === 'Copy') {
                                            if (item.xid === currentFolder) {
                                                scope.setDisabled = true;
                                                //actionBtn.attr('disabled', true);
                                                return;
                                            }
                                            else {
                                                scope.setDisabled = false;
                                                //actionBtn.attr('disabled', false);
                                            }
                                        }
                                        // move
                                        else if (scope.content.type === 'Move') {
                                            if (actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') != 'true') {
                                                actionBtn.attr('atParent', true);
                                            }
                                            else {
                                                actionBtn.attr('atParent', item.xid === currentFolder);
                                            }
                                            actionBtn.attr('atRoot', scope.currentCollectionId == currentFolder);
                                            var withinColl = actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') == 'false';
                                            if (item.parent.cid === currentFolder || item.xid === currentFolder || withinColl) {
                                                scope.setDisabled = true;
                                                //actionBtn.attr('disabled', true);
                                                return;
                                            }
                                            else {
                                                scope.setDisabled = false;
                                                //actionBtn.attr('disabled', false);
                                            }
                                        }
                                    }
                                    // multiple assets
                                    else {
                                        // copy
                                        if (scope.content.type === 'Copy') {
                                            if (item.parent.cid === currentFolder) {
                                                scope.setDisabled = true;
                                                // actionBtn.attr('disabled', true);
                                                return;
                                            }
                                            else {
                                                scope.setDisabled = false;
                                                // actionBtn.attr('disabled', false);
                                            }
                                        }
                                        // move
                                        else if (scope.content.type === 'Move') {
                                            if (actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') != 'true') {
                                                actionBtn.attr('atParent', true);
                                            }
                                            else {
                                                actionBtn.attr('atParent', item.parent.cid === currentFolder);
                                            }
                                            actionBtn.attr('atRoot', scope.currentCollectionId == currentFolder);
                                            var withinColl = actionBtn.attr('atParent') == 'true' && actionBtn.attr('atRoot') == 'false';
                                            if (item.parent.cid === currentFolder || withinColl) {
                                                scope.setDisabled = true;
                                                //actionBtn.attr('disabled', true);
                                                return;
                                            }
                                            else {
                                                scope.setDisabled = false;
                                                //actionBtn.attr('disabled', false);
                                            }
                                        }
                                        else {
                                            scope.setDisabled = false;
                                        }
                                    }
                                }
                            }
                            if (["100","101", "103", "104", "106"].includes(currentFolder))
                                scope.setDisabled = true;
                        }
                    })

                    scope.handleModalBtnKeyDown = function(e) {
                        if(e.which === 9 && !e.shiftKey) {
                            var closeBtn = document.querySelector('#itemManagementWindow .modal-dialog .btn-blank.btn-close');
                            closeBtn.focus();
                        }
                    }
                    $(document).on("keydown.itemmanagementdirective", function (e) {
                        if (e.which === 27) {
                            scope.closeFolderSelectionModal();
                        }
                    });
                    scope.$on('$destroy', function() {
                        console.log('item-management.directive.js controller is being destroyed, performing cleanup...');
                        $(document).off("keydown.itemmanagementdirective");
                    });
                }
            }
        }
    }]);
